<template>
  <apexchart
    type="radar"
    :height="height"
    :options="chartOptions"
    :series="series"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'Radar',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    chartData: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: '500'
    }
  },
  computed: {
    series() {
      const series = []

      this.chartData.forEach(data => {
        if (data.playerResult) {
          const serie = {
            name: this.displayDate(data.playerResult.endDate),
            data: []
          }

          const results = data.playerResult.result.allSoftSkillResults

          Object.entries(results).forEach(([skill, score]) => {
            serie.data.push(results[skill])
          })

          series.push(serie)
        }
      })

      return series
    },
    chartOptions() {
      let chartOptions = {
        labels: ['ACCOUNTABILITY', 'ADAPTABILITY', 'DECISION MAKING', 'ENTREPRENEURSHIP', 'FLEXIBILITY', 'INTEGRITY', 'LEARNIGN AGILITY', 'PEOPLE SUPPORT', 'PROJECT MANAGEMENT', 'RESILIENCE', 'TEAMWORK'],
        colors: ['#fec424', '#f4516c', '#36a3f7'],
        fill: {
          opacity: [1, 0.5, 0.1]
        },
        markers: {
          size: 5,
          hover: {
            size: 10
          }
        },
        plotOptions: {
          radar: {
            size: 100
          }
        },
        xaxis: {
          labels: {
            style: {
              fontSize: '8px',
              fontWeight: 800
            }
          }
        },
        yaxis: {
          show: false
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        legend: {
          onItemClick: {
            toggleDataSeries: false
          }
        }
      }
      return chartOptions
    }
  }
}
</script>
